export default [0, 6, 12, 16, 18]
